export default __webpack_public_path__ + "static/media/abusedPets.822f8f17.webp";